// Mirrors the catering inquiry form (a native Shopify contact form that emails
// the restaurant) to the admin app's /api/catering-leads endpoint so every
// inquiry becomes a trackable lead. Config comes from data-* attributes on the
// [data-catering-inquiry-capture] wrapper; we do not preventDefault, so the
// Shopify submission still happens as before.
(function () {
  function init() {
    var wrappers = document.querySelectorAll('[data-catering-inquiry-capture]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var url = wrapper.getAttribute('data-admin-api-url') || '';
      var key = wrapper.getAttribute('data-admin-api-key') || '';
      if (!url || !key) return;

      var fallbackLang = wrapper.getAttribute('data-locale') || 'en';

      wrapper.querySelectorAll('form').forEach(function (form) {
        form.addEventListener('submit', function () {
          var get = function (id) {
            var el = form.querySelector('#' + id);
            return el && el.value ? el.value.trim() : '';
          };

          var name = get('CateringForm-name');
          if (!name) return;

          var lang = (window.Shopify && window.Shopify.locale) || fallbackLang;
          lang = lang === 'fr' ? 'fr' : 'en';

          try {
            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-API-Key': key,
              },
              body: JSON.stringify({
                name: name,
                phone: get('CateringForm-phone'),
                email: get('CateringForm-email'),
                event_datetime: get('CateringForm-datetime'),
                guest_count: get('CateringForm-guest-number'),
                message: get('CateringForm-body'),
                referral_source: get('CateringForm-referral'),
                locale: lang,
                source: 'catering_inquiry_form',
              }),
              keepalive: true,
              mode: 'cors',
            }).catch(function () { /* swallow — Shopify submission is primary */ });
          } catch (_) { /* swallow */ }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
